<script setup lang="ts">

import { ElementTip } from '@/stores/ElementTip'
import { Utill } from '@/stores/Utill'
import { Data } from '@/stores/data'
import useClipboard from 'vue-clipboard3'
import { ref } from 'vue'

var def = defineProps({
  backText: {
    type: [String, Object],
  },
})

// let imgUrl = Data.isReg.value
//   ? window.xh_wen_data.url
//   : 'https://ikeben.cn/chat/web/public/img/my-head.png';

// let imgUrl = '@/assert/user-icon.png'

let imgUrl = ref(Data.userInfo.value?.headimgurl ? Data.userInfo.value?.headimgurl : 'https://static.yipigai.cn/theme/20240722191033_57291.png')

function isUrlStr(text: any) {
  if (typeof text === 'string') {
    if (Utill.isURL(text as string)) {
      const regex = /(https?:\/\/[^\s]+)/g
      const strArr = []
      let match
      let lastIndex = 0
      while ((match = regex.exec(text)) !== null) {
        // 将匹配到的链接之前的文字存入数组
        if (match.index !== lastIndex) {
          strArr.push(text.substring(lastIndex, match.index))
        }
        // 将匹配到的链接存入数组
        strArr.push(match[0])
        // 更新 lastIndex
        lastIndex = regex.lastIndex
      }

      // 将最后一个链接后的文字存入数组（如果有的话）
      if (lastIndex < text.length) {
        strArr.push(text.substring(lastIndex))
      }
      return strArr
    }
  }
  return false
}
// 使用插件
const { toClipboard } = useClipboard()

const copy = async (msg: string) => {
  try {
    // 复制
    await toClipboard(msg)
    ElementTip.successTip('复制成功')
    // 复制成功
  } catch (e) {
    // 复制失败
    ElementTip.errorTip('复制失败')
  }
}

// 点击复制
function touchCopy(text: string) {
  if (Utill.isURL(text as string)) {
    copy(text)
  }
  // 调用

}
</script>

<template>
  <div class="mess-ctr">
    <div class="text-ctr">
      <!-- 这里不用能 v-html，因为如果用 v-html输入html标2签会被转化 -->
      <div v-if="typeof backText === 'string' || !backText?.isHtml">
        <div v-if="isUrlStr(backText)" class="url-ctr">
          <span v-for="(file, index) in isUrlStr(backText)" :class="Utill.isURL(file) ? 'url_color' : ''"
            @click="touchCopy(file as string)">{{ file }}</span>
        </div>
        <p v-else>
          {{ backText }}
        </p>
      </div>

      <p v-html="(backText as any).text"></p>
    </div>
    <!--    <div class="cro">-->
    <!--      <div class="cro_left_top"></div>-->
    <!--    </div>-->
    <div class="cro-new">
      <img class="cro-img" src="@/assets/cro-right.svg" alt="">
    </div>
    <div class="avatar">
      <!--      <img class="rounded-circle" :src="imgUrl" alt="avatar" />-->
      <img class="rounded-circle" :src="imgUrl" alt="avatar" />
    </div>
  </div>

</template>

<style scoped lang="scss">
.url-ctr span {
  display: inline-block;
  max-width: 100%;
}

.url_color {
  color: #59aded;
}

.cro {
  transform: rotate(180deg);
  background-color: #5570F1;
}

.mess-ctr {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  overflow: hidden;
  -webkit-animation: msgRight 0.5s ease-in-out;
  animation: msgRight 0.5s ease-in-out;
  padding: 2px 0px 14px 33px;
  font-size: 16px;
}

.rounded-circle {
  display: block;
}

.avatar {
  min-width: 35px;
  min-height: 35px;
  border-radius: 30px;
  overflow: hidden;

  height: 35px;
  width: 35px;
  flex-shrink: 0;
}

.text-ctr {
  word-wrap: break-word;
  white-space: pre-wrap;
  background: linear-gradient(270deg, #9786FA 0%, #898FFA 100%);
  border-radius: 16px 0px 16px 16px;
  //max-width: calc(100% - 35px);
  // max-width: 279px;
  min-width: 0;
  box-sizing: border-box;
  /* margin-right: 0.06rem; */
  line-height: 24px;
  overflow: hidden;
  color: #FFFFFF;
  padding: 12px;
}

.cro-new {
  display: flex;
  justify-content: start;
  width: 8px;
  height: 8px;
  margin-left: -1px;
  flex-shrink: 0;
}

.cro-img {
  width: 8px;
  height: 8px;
}
</style>